import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Modal, Select } from '@mantine/core';
import {
  selectedSpeciesModelSelector,
  setLoadingMessage,
  setSelectedSpeciesModel,
  setShowGlobalLoading,
  speciesModelOptionsSelector,
} from '../../../store/slices/appSlice';
import { tokenSelector } from '../../../store/slices/authSlice';
import WFIDButton from '../../../components/WFIDButton/WFIDButton';
import { URLS } from '../../../config/aws.config';
import { NotificationType, showNotification } from '../../../utils/showNotifications';
import { getModelDataResponse } from '../services';

const ModalDeleteComponent = (props: any) => {
  const { open, message, onChange, onCancel } = props;

  return (
    <div>
      <Modal radius={8} size='lg' opened={open} centered onClose={onCancel} withCloseButton={false}>
        <div className='ModalNotification__header'>
          <p>{message}</p>
        </div>
        <div className='modal-delete-btns-contaner'>
          <div className='modal-btn-container'>
            <WFIDButton content='Cancel' onClick={onCancel} />
          </div>
          <div className='modal-btn-container'>
            <WFIDButton color='white' bgColor='#9C1212' content='Delete' onClick={onChange} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

const DeleteModelGenusS3Data = () => {
  const selectedSpeciesModel = useSelector(selectedSpeciesModelSelector);
  const speciesModelOptions = useSelector(speciesModelOptionsSelector);
  const [selectedSpeciesOption, setSelectedSpeciesOption] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = useSelector(tokenSelector);

  const dispatch = useDispatch();

  const handleDelete = () => {
    setIsModalOpen(true);
  };
  const handleSpeciesChange = (value: string | null, options: any) => {
    dispatch(setSelectedSpeciesModel(value));
    setSelectedSpeciesOption(options);
  };

  const handleConfirmDelete = async () => {
    const baseUrl = URLS.delete_model_prediction_genus;
    const originalFileName = selectedSpeciesOption.originalFileName;
    dispatch(setShowGlobalLoading(true));
    dispatch(setLoadingMessage('Deleting...'));

    const url = `${baseUrl}?key=${encodeURIComponent(originalFileName)}&token=${encodeURIComponent(token as string)}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (!data?.message) {
        showNotification({
          type: NotificationType.Error,
          title: 'Error',
          message: 'There was an error deleting the data model, please try again',
        });

        dispatch(setShowGlobalLoading(false));
        dispatch(setLoadingMessage(''));
        return;
      }
      showNotification({
        type: NotificationType.Success,
        title: 'Success',
        message: `"${selectedSpeciesOption.value}" data model deleted successfully`,
      });
      setIsModalOpen(false);
      dispatch(setSelectedSpeciesModel(null));
      dispatch(setShowGlobalLoading(false));
      dispatch(setLoadingMessage(''));

      // get the updated list of models
      await getModelDataResponse();
    } catch (errr) {
      console.log(errr);
    }
  };
  return (
    <div>
      <div>
        <Select
          w='300px'
          searchable
          value={selectedSpeciesModel}
          label='Select species'
          onChange={handleSpeciesChange}
          placeholder='Select species'
          data={speciesModelOptions}
          clearable
        />
      </div>
      <div className='admin-buttons-container'>
        <WFIDButton disabled={!selectedSpeciesModel} bgColor='white' content='Delete' onClick={handleDelete} />
      </div>

      <ModalDeleteComponent
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        message='Are you sure you want to delete this data model? this action cannot be undone.'
        onChange={handleConfirmDelete}
      />
    </div>
  );
};

export default DeleteModelGenusS3Data;
